import { createDraftSafeSelector, Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { fetchTerminalsByIdsThunk } from "../../../../Store/Thunks/terminalsByIds";
import { createAsyncEntitySlice } from "../../../../Store/Entities/createAsyncEntitySlice";
import { TerminalInfo } from "../GQLCalls/getTerminalsCall";
import { AsyncEntityState } from "../../../../Store/Thunks/asyncEntityStateUtil";
import { RootState } from "../../../../Store";
import { EnqueueFetcher } from "../../../../Store/Thunks/enqueueFetcher";
import { entityByIdWithStatusHookFactory } from "../../../../Store/Entities/entityByIdWithStatusHookFactory";


// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice<TerminalInfo, number, SliceCaseReducers<AsyncEntityState<TerminalInfo, number>>,TerminalInfo>({
  name: "terminals",
  reducers: {
    },
  fetchByIdsThunk: fetchTerminalsByIdsThunk,
  selectId:(terminal) => terminal.terminal_id
})

export const terminalReducer = reducer as Reducer<AsyncEntityState<TerminalInfo, number>>;

const selectState = (state: RootState) => state.graphQlData.terminals;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectTerminalById, selectAll: SelectAllTerminals} = entityAdapter.getSelectors(selectState);

const terminalFetcher = new EnqueueFetcher(fetchTerminalsByIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

export const dispatchFetchTerminalById = terminalFetcher.enqueueFetchById

export const selectTerminalByIds = createDraftSafeSelector([SelectAllTerminals, (_, terminalIds: number[]) => terminalIds], (terminals: TerminalInfo[], terminalIds) => {
  return terminals.filter((terminal) => terminalIds.includes(terminal.terminal_id));
})

const selectLoadingIds = getSelectors(selectState).selectLoadingIds;
export const useTerminalById = entityByIdWithStatusHookFactory(dispatchFetchTerminalById, selectTerminalById, selectLoadingIds )
